export const ADDTOCART = "addToCart";
